import { Group } from '@mantine/core';
import { Product } from '../../products/types';
import { CreateStripeProductButton } from '../buttons/CreateStripeProductButton';
import { UpdateStripeProductButton } from '../buttons/UpdateStripeProductButton';
import { DeleteStripeProductButton } from '../buttons/DeleteStripeProductButton';

interface StripeProductButtonsProps {
    product: Product;
    onProductUpdated?: (stripeProductId: string) => void;
}

export const StripeProductButtons = ({ product, onProductUpdated }: StripeProductButtonsProps) => {
    const hasStripeProduct = !!product.billingProviderRecordId;
    const isStripeProvider = !!product.billingProviderId;

    if (!isStripeProvider) {
        return null;
    }

    return (
        <Group gap="xs">
            {!hasStripeProduct ? (
                <CreateStripeProductButton 
                    product={product} 
                    onProductCreated={onProductUpdated} 
                />
            ) : (
                <>
                    <UpdateStripeProductButton product={product} />
                    <DeleteStripeProductButton 
                        product={product} 
                        onProductDeleted={() => onProductUpdated?.('')} 
                    />
                </>
            )}
        </Group>
    );
};